import { InjectionToken } from "@angular/core";
import { ILivekitClient } from "./i-livekit.client";

export const livekitClientInjectionToken: InjectionToken<ILivekitClient> = new InjectionToken<ILivekitClient>("digital-signage.user-dashboard.dashboard-web.LivekitClient");
